import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FilterOption } from 'src/app/shared/models/filter-option';
import { FilterResponse } from 'src/app/shared/models/filter-response';

export interface SelectOption extends FilterOption {
    value: boolean | number | string;
}

@Component({
    selector: 'cdp-yes-no-select',
    templateUrl: './yes-no-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class YesNoSelectComponent {
    @Input() selection: boolean | null = null;
    @Input() placeholder: string;
    @Input() tooltip?: string;
    @Input() controlName: string;
    @Input() bindLabel: string;

    @Output() selectionChange: EventEmitter<Array<FilterResponse<boolean | null>>> = new EventEmitter<
        Array<FilterResponse<boolean | null>>
    >();

    readonly selectOptions: SelectOption[] = [
        { display: 'Yes', value: true },
        { display: 'No', value: false }
    ];

    onChange(selection: Array<FilterResponse<boolean | null>>): void {
        this.selectionChange.emit(selection);
    }
}
